import {
  getRequest,
  getRequestOfExam,
  postRequestByJson,
  postRequestByBlob,
  putRequest,
  deleteRequest,postRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { Message } from "element-ui";

function myThen(data) {
  try {
    if (data.status) {
      return Promise.resolve(data.data);
    } else {
      Message.error(data.failMsg);
      return Promise.reject(data.failMsg);
    }
  } catch (e) {
    return Promise.resolve(data);
  }
}

// 对账列表
export const getBillList = (params = {}) => {
  return postRequest("/base/bill/list", params).then(myThen);
};
// 对账编辑
export const updateBill = (params = {}) => {
  return postRequest("/base/bill/update", params).then(myThen);
};

// 对账统计
export const billConsult = (params = {}) => {
  return postRequest("/base/bill/finance", params).then(myThen);
};
// 导入对账信息
export const importBillInformationByAli = (params = {}) => {
  return postRequest("/base/common/importAliPayBill", params).then(
    myThen
  );
}; // 导入对账信息
export const importBillInformationByWechat = (params = {}) => {
  return postRequest("/base/common/importWeXinBill", params).then(myThen);
};
// 导出对账信息
export const exportBillInformation = (params = {}) => {
  return postRequest("/base/bill/finance", params).then(myThen);
};
